import classnames from 'classnames'

export const cls = (...inputs) => classnames(inputs)
